import React from 'react';
import PropTypes from 'prop-types';

const ChatInput = ({
  input,
  setInput,
  fetchResponseOrStream,
  loading,
}) => {
  const handleClear = () => setInput('');

  const handlePaste = async () => {
    const text = await navigator.clipboard.readText();
    setInput(text);
  };

  return (
    <div>
      <textarea
        value={input}
        onChange={(e) => setInput(e.target.value)}
        placeholder="Enter your prompt"
      />
      <button type="button" onClick={fetchResponseOrStream} disabled={loading}>Send</button>
      <button type="button" onClick={handleClear}>Clear</button>
      <button type="button" onClick={handlePaste}>Paste</button>
    </div>
  );
};

ChatInput.propTypes = {
  input: PropTypes.string.isRequired,
  setInput: PropTypes.func.isRequired,
  fetchResponseOrStream: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default ChatInput;
